export const metricTypes: any = {
    webpageviews: { title: "Web page views", metric: "web" },
    apppageviews: { title: "App page views", metric: "app" },
    pageviews: { title: "Page views", metric: "total" },
    videoPageViews: { title: "Streamstarts", metric: "video" },
    conversion: { title: "Conversion", metric: "conversion" },
    totalReadingTime: { title: "Total Reading time (hrs)", metric: "totalReadingTime" },
    totalVisitors: { title: "Total Visitors", metric: "totalVisitors" },
    appVisitors: { title: "App visitors", metric: "appVisitors" },
    webVisitors: { title: "Web visitors", metric: "webVisitors" },
};

export const RANGE_EXTEND = 5;

export const RedArrow = <span style={{ color: "red" }}>▼</span>;
export const GreenArrow = <span style={{ color: "green" }}>▲</span>;